module.exports = __webpack_public_path__ + "images/social-icons/linkedin-icon.943a281916c6d159cd3e.svg";